import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';
import { makeStyles } from '@material-ui/core/styles';

export type SummaryRefundableAmountStylesClasses = 'container' | 'iconContainer' | 'icon' | 'labelContainer' | 'title';

const summaryReservationStyles = makeStyles<ISpcTheme, SummaryRefundableAmountStylesClasses>(
  ({ palette, typography }) => ({
    container: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: palette.primary.main,
      padding: '8px 6px',
    },
    icon: {
      stroke: palette.common.white,
      color: palette.common.white,
      fontSize: 50,
    },
    iconContainer: {
      margin: 'auto 2px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    labelContainer: {
      margin: '0 0 0 5px',
      color: palette.common.white,
    },
    title: {
      fontWeight: typography.fontWeightBold,
    },
  }),
  { name: 'Customise_SummaryLinks' },
);

export default summaryReservationStyles;
